/* DurationComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./DurationRenderer");
const _ = require("lodash");

class DurationComponent extends DefaultColumnComponent {
    constructor(entity) {
        const duration =
            entity && entity.completedOn && entity.executedOn
                ? entity.completedOn - entity.executedOn
                : null;
        super(duration);
        this._value = duration;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._value = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newEntity) {
        if (!_.isUndefined(newEntity)) {
            this.setDuration(newEntity);
        }
    }

    getValue() {
        return this.getDuration();
    }

    setDuration(newEntity) {
        this._value =
            newEntity && newEntity.completedOn && newEntity.executedOn
                ? newEntity.completedOn - newEntity.executedOn
                : null;
        this.emit("Duration", this._value);
        return this;
    }

    getDuration() {
        return this._value;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DurationComponent;
